import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createOrUpdateProfile, getProfileById, deleteProfileById, uploadProfileImage, getRecommendedProfiles } from "../services/profileService";
import { setFilters } from "./matchFilterSlice";

// Async thunk to fetch profile by ID
export const fetchProfile = createAsyncThunk(
  "profile/fetchProfile",
  async (id, thunkAPI) => {
    try {
      const res = await getProfileById(id);
      return res;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
 
  }
);

// update user profile
export const updateProfile = createAsyncThunk(
  "profile/updateProfile",
  async ({id, ...profileData }, thunkAPI) => {
    try {
      const res = await createOrUpdateProfile(id,profileData);
      return res;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

//for admin create update profile
export const updateProfileWithImage = createAsyncThunk(
  "profile/updateProfileWithImage",
  async ({ id, formData }, thunkAPI) => {
    try {
      const res = await createOrUpdateProfile(id, formData);
      return res;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// delete user profile
export const deleteProfile = createAsyncThunk(
  "profile/deleteProfile",
  async (id, thunkAPI) => {
    try {
      const res = await deleteProfileById(id);
      return res;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// profile image upload
export const uploadUserProfileImage = createAsyncThunk(
  "profile/uploadProfileImage",
  async ({ profileId, formData  }, thunkAPI) => {
    try {
      const res = await uploadProfileImage(profileId, formData);
      return res;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

//Get recommanded matches based on profile filters
export const fetchRecommendedMatches = createAsyncThunk(
  "profile/fetchRecommendedMatches",
  async (_, thunkAPI) => {
    try {
      const res = await getRecommendedProfiles();
      return res;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);


const profileSlice = createSlice({
  name: "profile",
  initialState: {
    data: null,
    loading: false,
    error: null,
    recommendedMatches: [],
  },
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
  },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProfile.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProfile.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateProfile.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(updateProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deleteProfile.fulfilled, (state, action) => {
                state.loading = false;
                state.data = null;
            })
            .addCase(deleteProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            }).addCase(uploadUserProfileImage.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.profile) {
                  state.data = action.payload.profile; 
                }
            }).addCase(uploadUserProfileImage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            }).addCase(fetchRecommendedMatches.fulfilled, (state, action) => {
                state.loading = false;
                state.recommendedMatches = action.payload;
            }).addCase(fetchRecommendedMatches.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            }).addCase(updateProfileWithImage.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            }).addCase(updateProfileWithImage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
          }

});
export const { clearProfile } = profileSlice.actions;
export default profileSlice.reducer;